import { Pipe } from '@angular/core';
import { AccessControlGatePlateDto } from '../dtos/accesscontrol/gate/plate/AccessControlGatePlateDto';
import { HDateHour } from '../datatypes/HDateHour';
import { SortByPipe } from './SortByPipe';

@Pipe({
	name: "orderbyaccesscontrolgateplatedto"
})
export class OrderByAccessControlGatePlateDto {
	transform(array: Array<AccessControlGatePlateDto>, asc: boolean): Array<AccessControlGatePlateDto> {
		if (array == null)
			return null;


		array.sort((a: AccessControlGatePlateDto, b: AccessControlGatePlateDto) => {
			//Nova manera de buscar
			if (asc)
				return SortByPipe.compareAny(a.orderString, b.orderString);
			SortByPipe.compareAny(b.orderString, a.orderString);

			//if (asc)
			//	return OrderByAccessControlGatePlateDto.compareAny(a, b);
			//return OrderByAccessControlGatePlateDto.compareAny(b, a);
		});
		return array;
	}

	public static compareAny(a: AccessControlGatePlateDto, b: AccessControlGatePlateDto): number {
		//Primer han d'anar els que tenen la marca de callInToDock o callOutToDock
		if ((a.callInToDock || a.callOutToDock))
			return -1;
		if ((a.callInToDock || a.callOutToDock) && (!b.callInToDock && !b.callOutToDock))
			return -1;
		if ((b.callInToDock || b.callOutToDock))
			return 1;
		if ((!a.callInToDock && !a.callOutToDock) && (b.callInToDock || b.callOutToDock))
			return 1;

		return this.validateDateHour(a, b);
	}

	public static validateDateHour(a: AccessControlGatePlateDto, b: AccessControlGatePlateDto): number {

		//Primer poso les que tenen slot
		if (!HDateHour.isNullOrNullValue(a.orderHDateHour) && !HDateHour.isNullOrNullValue(b.orderHDateHour)) {
			if (HDateHour.isGreaterEqualsThan(a.orderHDateHour, b.orderHDateHour))
				return 1;
			else if (HDateHour.isMinor(a.orderHDateHour, b.orderHDateHour))
				return -1;
		}
		else if (!HDateHour.isNullOrNullValue(a.orderHDateHour) && HDateHour.isNullOrNullValue(b.orderHDateHour))
			return -1;
		else if (HDateHour.isNullOrNullValue(a.orderHDateHour) && !HDateHour.isNullOrNullValue(b.orderHDateHour))
			return 1;

		if (HDateHour.isNullOrNullValue(a.orderHDateHour) && HDateHour.isNullOrNullValue(b.orderHDateHour))
			return a.routeKey > b.routeKey ? 1 : -1;
		if (HDateHour.isNullOrNullValue(a.orderHDateHour) && !HDateHour.isNullOrNullValue(b.orderHDateHour))
			return 1;
		if (!HDateHour.isNullOrNullValue(a.orderHDateHour) && HDateHour.isNullOrNullValue(b.orderHDateHour))
			return -1;
		if (HDateHour.isGreater(a.orderHDateHour, b.orderHDateHour))
			return 1;
		if (HDateHour.equals(a.orderHDateHour, b.orderHDateHour))
			return a.routeKey > b.routeKey ? 1 : -1;
		return -1;
	}
}
